import React from "react";
import { Link } from "react-router-dom";

const HeaderMenu = () => (
  <div className="HeaderMenuWrapper">
    <ul>
      <li className="first">
        <Link to="/">Today</Link>
      </li>
      <li>
        <Link to="/recent">Recent</Link>
      </li>
      <li className="navNew">
        <Link to="/thisday">
          Today In History
          <span className="navNewBadge">New</span>
        </Link>
      </li>
      <li>
        <Link to="/search">Search</Link>
      </li>
      <li>
        <Link to="/about">About</Link>
      </li>
    </ul>
  </div>
);

export default HeaderMenu;
